import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useSnackbar } from "notistack";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Badge,
  Label,
  Input,
  FormGroup,
  DropdownItem,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormFeedback,
  InputGroup,
  Spinner,
  Tooltip,
} from "reactstrap";
import BackButtonSvg from "../../common/BackButtonSvg";

import API from "../../../redux/actions/API";
import {
  UPLOAD_FILE,
  DOG_LICENSE_DETAILS,
  UPDATE_LICENSE_STATUS,
  REFUND_PAYMENT,
} from "../../../constants/ApiPaths";

import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import Swal from "sweetalert2";

import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { JSONParser } from "../../../functions/Helper";
import AgencyPreviewform from "./AgencyPreviewform";
import { CSVLink } from "react-csv";
import moment from "moment";
import { Info } from "../../common/Info";
import ReuploadFormValue from "../../User/License/ReuploadFormValue";
import { getAdminUserId, getAgencyURL } from "../../common/CommonFunctions";
import { useSelector } from "react-redux";
import { AGENCY_LICENSE_ROUTE } from "../../../constants/RoutePaths";
const initailValue = {
  validFromDate: "",
  validToDate: "",
  dogLicenseNumber: "",
};
function ViewLicense() {
  const history = useNavigate();
  const pathname = window.location.pathname.split("/")[1];
  const [pdf, setpdf] = useState("");
  const { licensePlanId, dogLicenseId } = useParams();
  const [licenseDetails, setlicenseDetails] = useState({});
  const [reqNu, setreqNu] = useState(true);
  const [Reupload, setReupload] = useState(initailValue);
  const [loading, setloading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [DeleverSpinner, setDeleverSpinner] = useState(false);
  const [isEditable, setisEditable] = useState(true);
  const DeleteAgency = useSelector((state) => state.Agencydelete);

  const {
    licensePlanDetails,
    categoryDetails,
    licenseComments,
    licenseStatus,
    paymentDetails,
    licenseRequiredDocDetails,
    dogId,
  } = licenseDetails;
  const paymentData = JSONParser(paymentDetails, []);
  const paymaentid = paymentData[0];
  const licensePlanData = JSONParser(licensePlanDetails, []);
  const categoryData = JSONParser(categoryDetails, []);
  const document = JSONParser(licenseRequiredDocDetails, []);
  const [modal, setModal] = useState(false);
  const Datetoggle = () => {
    setreqNu(true);
    setModal(!modal);
    handleUpdateValidationDateOnClick();
  };
  const Answer = categoryData.map((ans) => JSONParser(ans.categoryAnswer, []));
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const csvHeaders = [];
  const csvAnswer = {};
  const { planName, planDuration, isLifeTimePlan, validTo } = licensePlanData[0] || {};

  Answer.forEach((A, index) => {
    A.categoryPlaceHolder.forEach((field) => {
      csvHeaders.push({ label: field?.label, key: field.uniqueId });
      if (["select", "checkbox", "radio"].includes(field.type)) {
        let fieldValueAnswer = field.selectedAnswer;
        if (field.type === "checkbox") {
          const CheckboxAnswer = [];
          field.options.forEach((option) => {
            if (fieldValueAnswer.includes(option.value)) {
              CheckboxAnswer.push(option.value);
            }
          });
          fieldValueAnswer = CheckboxAnswer.join(",");
        } else {
          const fieldValue = field.options.find(
            (o) => o.value === field.selectedAnswer
          );
          fieldValueAnswer = !!field.selectedAnswer && fieldValue?.label;
        }
        csvAnswer[field.uniqueId] = fieldValueAnswer;
      } else {
        csvAnswer[field.uniqueId] = field.selectedAnswer;
      }
    });
  });

  const csvAnswers = [csvAnswer];

  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const dogLicenseDetails = async (e) => {
    const config = {
      method: "GET",
      url: DOG_LICENSE_DETAILS,
      // headers: pathname == "customer" ? authCustomerHeader() : authHeader(),
      params: {
        dogLicenseId: dogLicenseId,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setlicenseDetails(data);
        setReupload({
          validFromDate: data.requestedDate,
          validToDate: data.validToDate,
          dogLicenseNumber: data.dogLicenseId,
        });
        setValidDateTo1(data.validToDate);
        // if (data.validToDate) {
          setValidDateTo2(data.validToDate);
        // } else {
          
        // }
        
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setloading(false);
    }
  };

  function RejectLicense(e) {
    if (DeleteAgency) {
      return;
    }
    Swal.fire({
      input: "textarea",
      inputLabel: "Please enter reason for rejecting license",
      inputPlaceholder: "Enter your comments",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "Enter reject message";
        } else {
          const Comments = value;
          const Statues = "Rejected";
          UpdateLicense(Statues, Comments);
        }
      },
    });
  }
  function ApproveLicense(e) {
    if (DeleteAgency) {
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Are You Want to Approve this License!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Approve it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const Statues = "License Approved";
        const Comments = "";
        UpdateLicense(Statues, Comments);
      }
    });
  }

  function IssueLicense(e) {
    if (DeleteAgency) {
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Are You Want to Issue this License!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Issue it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const Statues = "License Issued";
        const Comments = "";
        UpdateLicense(Statues, Comments);
      }
    });
  }

  const UpdateLicense = async (Statues, Comments) => {
    if (DeleteAgency) {
      return;
    }
    setloading(true);
    const config = {
      method: "PUT",
      url: UPDATE_LICENSE_STATUS,
      data: {
        dogLicenseId: dogLicenseId,
        licenseStatus: Statues,
        licensePlanId: licensePlanId,
        // hyperLink: `${
        //   window.location.origin
        // }/customer/${getAgencyURL()}/view-license/${dogLicenseId}`,
        licenseUrl:
          Statues === "License Issued"
            ? null
            : `${
                window.location.origin
              }/customer/${getAgencyURL()}/view-license/${dogLicenseId}`,
        hyperLink:
          Statues === "License Approved"
            ? `${window.location.origin}/payment/`
            : Statues === "Rejected"
            ? `${
                window.location.origin
              }/customer/${getAgencyURL()}/view-license/${licensePlanId}/${dogLicenseId}`
            : null,
        approvedBy: getAdminUserId(),
        licenseComments: Comments,
        isSubmitToAgency: false,
      },
      // headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status, message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        dogLicenseDetails();
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setloading(true);
    }
  };

  const pdfChange = async (e) => {
    setDeleverSpinner(true);
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const formDatas = new FormData();
      formDatas.append("file", selectedFile);
      const config = {
        method: "POST",
        url: UPLOAD_FILE,
        data: formDatas,
        // headers: authHeader(),
      };
      try {
        const response = await API(config);
        const { status, filePath } = response.data;
        if (status === "Success") {
          setpdf(filePath);
        }
      } catch (error) {
        if (error.response) {
          const { data } = error.response;
          CustomAlertMessage(data.message, "error", enqueueSnackbar);
          setDeleverSpinner(false);
        }
      } finally {
        setDeleverSpinner(false);
      }
    }
    setDeleverSpinner(false);
  };

  useEffect(() => {
    dogLicenseDetails();
  }, []);

  function LicenseGenerate(e) {
    if (DeleteAgency) {
      return;
    }
    Swal.fire({
      title: "Are You sure to deliver this License to customer?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Deliver",
    }).then((result) => {
      if (result.isConfirmed) {
        const Statues = "License Generated";
        GenerateLicense(Statues);
      }
    });
  }

  const GenerateLicense = async (Statues) => {
    if (DeleteAgency) {
      return;
    }
    setDeleverSpinner(true);
    const config = {
      method: "PUT",
      url: UPDATE_LICENSE_STATUS,
      data: reqNu
        ? {
            dogLicenseId: dogLicenseId,
            licenseStatus: Statues,
            licensePlanId: licensePlanId,
            approvedBy: getAdminUserId(),
            hyperLink: `${
              window.location.origin
            }/customer/${getAgencyURL()}/view-license/${dogLicenseId}`,

            licenseUrl: pdf,
            isSubmitToAgency: false,
            validFromDate: moment(values.validFromDate).format("MM/DD/YYYY"),
            validToDate:
             (!isLifeTimePlan && planDuration) ? moment(validDateTo1).format("MM/DD/YYYY") : (!isLifeTimePlan && validTo) ? moment(validDateTo2).format("MM/DD/YYYY")
                : values && values.validToDate ? moment(values.validToDate).format("MM/DD/YYYY")
                : "",
              // moment(values.validToDate).format("MM/DD/YYYY") !== "Invalid date"
              //   ? moment(values.validToDate).format("MM/DD/YYYY")
              //   : "",
            dogLicenseNumber: values.dogLicenseNumber,
          }
        : {
            dogLicenseId: dogLicenseId,
            licensePlanId: licensePlanId,
            hyperLink: `${
              window.location.origin
            }/customer/${getAgencyURL()}/view-license/${dogLicenseId}`,
            approvedBy: getAdminUserId(),
            isSubmitToAgency: false,
            validFromDate: moment(values.validFromDate).format("MM/DD/YYYY"),
          validToDate:
                (!isLifeTimePlan && planDuration) ? moment(validDateTo1).format("MM/DD/YYYY") : (!isLifeTimePlan && validTo) ? moment(validDateTo2).format("MM/DD/YYYY")
                : values && values.validToDate ? moment(values.validToDate).format("MM/DD/YYYY")
                : "",
              // moment(values.validToDate).format("MM/DD/YYYY") !== "Invalid date"
              //   ? moment(values.validToDate).format("MM/DD/YYYY")
              //   : "",
            dogLicenseNumber: values.dogLicenseNumber,
          },
      // headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status, message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        Datetoggle();
        dogLicenseDetails();
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setDeleverSpinner(false);
    }
  };

  const Refund = async (reson) => {
    setloading(true);
    const config = {
      method: "POST",
      url: REFUND_PAYMENT,
      data: {
        paymentDetailId: paymaentid.paymentDetailId,
        refundReason: reson,
      },
      // headers: authHeader(),
    };
    try {
      setDeleverSpinner(true);
      const response = await API(config);
      const { status, message } = response.data;

      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        dogLicenseDetails();
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setloading(false);
      setDeleverSpinner(false);
    }
  };

  const validationSchema = Yup.object().shape({
    validFromDate: Yup.string().nullable().required("Valid From Required"),
    // validToDate: Yup.string().nullable().required("Valid Till Required"),
    dogLicenseNumber: Yup.string()
      .nullable()
      .required("Dog License Number is required"),
  });

  const UpdateDate = () => {
    if (DeleteAgency) {
      return;
    }
    handleUpdateValidationDateOnClick();
    setreqNu(false);
    setModal(true);
  };

  const {
    handleSubmit,
    handleChange,
    values,
    handleBlur,
    errors,
    touched,
  } = useFormik({
    initialValues: Reupload,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => LicenseGenerate(values),
  });
  
  const [validDateTo1, setValidDateTo1] = useState(null);
  const [validDateTo2, setValidDateTo2] = useState(null);
  
  function handleUpdateValidationDateOnClick() { 
    const calDate = values && values.validToDate ? values.validToDate : moment(values.validFromDate).add(planDuration, 'year').format('YYYY-MM-DD');
    setValidDateTo1(calDate);
    const calToDate = values && values.validToDate ? values.validToDate : moment(validTo).format("YYYY-MM-DD");
    setValidDateTo2(calToDate);
  }
 function handleValidToDateChange1(e) {
   setValidDateTo1(e.target.value);
    
}
  function handleValidToDateChange2(e) {
      setValidDateTo2(e.target.value);
}
  // useEffect(() => {
  //   if (dogLicenseId) {
  //     setValues((prevValues) => ({
  //       ...prevValues,
  //       dogLicenseNumber: dogLicenseId,
  //     }));
  //   }
  // }, [dogLicenseId]);

  const ReuploadForm = () => {
    if (DeleteAgency) {
      return;
    }
    setisEditable(false);
  };

  const sucesscallback = () => {
    dogLicenseDetails();
    setisEditable(true);
  };

  const Cancellicense = async () => {
    if (DeleteAgency) {
      return;
    }
    Swal.fire({
      title: "Reason for Cancel",
      input: "text",
      showCancelButton: true,
      allowOutsideClick: false,
      inputPlaceholder: "Enter Reason for Cancel ",
      inputValidator: (value) => {
        if (!value) {
          return "Please enter the reason for Cancel";
        } else {
          Refund(value);
        }
      },
    });
  };

  const Showreason = (a) => {
    Swal.fire(a);
  };

  const Back = () => {
    history(AGENCY_LICENSE_ROUTE);
  };
  const changePaymentCompletedStatus = async() => {
    setloading(true);
     const conf = {
        method: "PUT",
        url: UPDATE_LICENSE_STATUS,
        data: {
          dogLicenseId: dogLicenseId,
          licenseStatus: "Payment Completed",
          licensePlanId: licensePlanId,
        },
      };
      try {
        const response1 = await API(conf);
         CustomAlertMessage('Payment successfully marked as completed.', "success", enqueueSnackbar);
         dogLicenseDetails();
         setloading(false);
      } catch (error) {
        console.error(error);
          if (error.response) {
          const { data } = error.response;
          CustomAlertMessage(data.message, "error", enqueueSnackbar);
          }
          setloading(false);
      }
  };
  return (
    <div>
      <div className="agency-wrapper">
        {/* <HeaderLogo /> */}
        {loading && <CustomPageLoading />}

        <Container fluid="lg">
          <div className="page-title">
            <h4>
              View License{" "}
              <Tooltip
                isOpen={id === "viewlicense" && tooltipOpen}
                target={"viewlicense"}
                toggle={() => tooltiptoggle("viewlicense")}
              >
                View license details
              </Tooltip>
              <span id={"viewlicense"}>
                <Info />
              </span>
            </h4>
            <h3>
              {!DeleteAgency
                ? pathname !== "customer" &&
                  licenseStatus !== "Rejected" && licenseStatus !== "Payment Completed" &&
                  !!licenseComments && (
                    <p>
                      {" "}
                      Reason for Reject{" "}
                      <span
                        onClick={() => Showreason(licenseComments)}
                        style={{ textDecoration: "underline", color: "blue" }}
                      >
                        {" "}
                        Show More{" "}
                      </span>
                    </p>
                  )
                : ""}
            </h3>
            <h3>
              {!DeleteAgency
                ? pathname === "customer" &&
                  licenseStatus === "Rejected" && (
                    <p>
                      {" "}
                      Rejected by Agency{" "}
                      <span
                        onClick={() => Showreason(licenseComments)}
                        style={{ textDecoration: "underline", color: "blue" }}
                      >
                        {" "}
                        Show More{" "}
                      </span>
                    </p>
                  )
                : ""}
            </h3>
            <div className="top-btn">
              {!DeleteAgency
                ? pathname !== "customer" && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                      <DropdownToggle color="danger" caret>
                        Export
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>
                          <CSVLink
                            filename={`${planName}.csv`}
                            data={csvAnswers}
                            headers={csvHeaders}
                          >
                            CSV
                          </CSVLink>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )
                : ""}
              <Button onClick={Back} color="primary">
                <BackButtonSvg /> Back
              </Button>
            </div>
          </div>

          <Card body className="mt-4 license-details">
            <div className="agency-license-view">
              <Row>
                <Col md='12' style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <h4>{planName}</h4>
                </Col>

                {!DeleteAgency ? (
                  ["Rejected"].includes(licenseDetails.licenseStatus) ? (
                    ""
                  ) : (
                    <Col md={{ size: "4", offset: 8 }} className="m-top">
                      {!DeleteAgency
                        ? pathname !== "customer" &&
                          licenseDetails.licenseStatus === "License Issued" && (
                            <Button onClick={UpdateDate}>
                              Update Validation Date range
                            </Button>
                          )
                        : ""}
                      {!DeleteAgency ? (
                        pathname !== "customer" &&
                        licenseDetails.licenseStatus === "License Approved" &&
                        paymaentid &&
                        paymaentid.paymentStatus === "Success" ? (
                          <div className="file-upload-btn-wrapper mb-3">
                            <button className="file-upload-btn">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19.945"
                                height="19.945"
                                viewBox="0 0 19.945 19.945"
                              >
                                <g
                                  id="Icon_feather-upload"
                                  data-name="Icon feather-upload"
                                  transform="translate(1 1)"
                                >
                                  <path
                                    id="Path_36"
                                    data-name="Path 36"
                                    d="M22.445,22.5v3.988a1.994,1.994,0,0,1-1.994,1.994H6.494A1.994,1.994,0,0,1,4.5,26.488V22.5"
                                    transform="translate(-4.5 -10.537)"
                                    fill="none"
                                    stroke="#1b3e6f"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                  />
                                  <path
                                    id="Path_37"
                                    data-name="Path 37"
                                    d="M20.469,9.485,15.485,4.5,10.5,9.485"
                                    transform="translate(-6.512 -4.5)"
                                    fill="none"
                                    stroke="#1b3e6f"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                  />
                                  <path
                                    id="Path_38"
                                    data-name="Path 38"
                                    d="M18,4.5V16.463"
                                    transform="translate(-9.028 -4.5)"
                                    fill="none"
                                    stroke="#1b3e6f"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                  />
                                </g>
                              </svg>
                              Upload a file
                            </button>
                            <Input
                              onChange={pdfChange}
                              type="file"
                              name="myfile"
                            />
                          </div>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}

                      {!DeleteAgency
                        ? pathname !== "customer" && (
                            <div className="btn-section">
                              {licenseDetails.licenseStatus ===
                                "License Approved" && (
                                <Button
                                  disabled={pdf === ""}
                                  onClick={Datetoggle}
                                  color={pdf === "" ? "primary" : "primary"}
                                >
                                  {DeleverSpinner ? <Spinner /> : "Deliver"}{" "}
                                </Button>
                              )}
                              {licenseDetails.licenseStatus ===
                                "License Generated" && (
                                <Button onClick={IssueLicense} color="primary">
                                  Issue
                                </Button>
                              )}

                              {licenseDetails.licenseStatus ===
                                "Payment Completed" && (
                                <>
                                  <Button
                                    onClick={ApproveLicense}
                                    color="primary"
                                  >
                                    Approve
                                  </Button>
                                  <Button
                                    onClick={RejectLicense}
                                    color="danger"
                                  >
                                    Reject
                                  </Button>
                                </>
                              )}
                              {licenseDetails.licenseStatus === "Pending" && (
                                <>
                                  <Button
                                    className="btn-section"
                                    onClick={RejectLicense}
                                    color="danger"
                                  >
                                    Reject
                                  </Button>
                                </>
                              )}
                            </div>
                          )
                        : ""}
                        { licenseStatus?.toLowerCase() === 'pay with agency' && (<Button
                    disabled={loading}
                    // className="ln-btn"
                    style={{width: '300px'}}
                    color="primary"
                    size="lg"
                    onClick={changePaymentCompletedStatus}
                  >
                    {/* {offlinePaymentLoader && <CustomButtonLoader loading={offlinePaymentLoader} />} */}
                    Mark as Payment Completed
                 </Button>)}
                    </Col>
                  )
                ) : (
                  ""
                )}
              </Row>
            </div>

            <h5>License Details</h5>

            {/* <Row> */}
            {!isEditable ? (
              <ReuploadFormValue
                setisEditable={setisEditable}
                sucesscallback={sucesscallback}
                categoryData={categoryData}
                dogId={dogId}
                document={document}
                Answer={Answer}
              />
            ) : (
              <AgencyPreviewform
                isEditable={isEditable}
                document={document}
                Answer={Answer}
              />
            )}
            {/* </Row> */}
            {!DeleteAgency
              ? pathname === "customer" &&
                isEditable && (
                  <div className="centerFlexRow">
                    {licenseStatus === "Rejected" && (
                      <>
                        {" "}
                        <Button color="primary" onClick={ReuploadForm}>
                          Resubmit
                        </Button>
                        <Button color="danger" onClick={Cancellicense}>
                          Cancel Order
                        </Button>
                      </>
                    )}
                  </div>
                )
              : ""}
            <h5 className="mt-5">Payment Details</h5>
            {paymentData.map((p) => (
              <Row className="license-details">
                <Col md="3">
                  <div className="info">
                    <p>{p.paymentDate}</p>
                    <span>Payment date</span>
                  </div>
                </Col>
                <Col md="3">
                  <div className="info">
                    <p>{p.planName}</p>
                    <span>Plan Name</span>
                  </div>
                </Col>
                <Col md="3">
                  <div className="info">
                    <p>{(p.totalAmount || 0).toFixed(2)}$</p>
                    <span>Paid Amount</span>
                  </div>
                </Col>
                <Col md="3">
                  <div className="info">
                    <p>
                      {" "}
                      <Badge
                        color={
                          p.paymentStatus === "Failed" ? "danger" : "success"
                        }
                      >
                        {" "}
                        {p.paymentStatus}
                      </Badge>{" "}
                    </p>
                    <span>Payment Status</span>
                  </div>
                </Col>
              </Row>
            ))}
          </Card>

          <Card body className="mt-5">
            <h5 className="mb-4">Plan Details</h5>

            <Row className="plan-list">
              {licensePlanData.map((li) => (
                <Col md="6" xl="4">
                  <div className="box">
                    <h4>{li.planName}</h4>
                    <h1>
                      <strong>$</strong>
                      {parseFloat(li.planAmount).toFixed(2)}
                    </h1>
                    <span>
                      {li.isLifeTimePlan && "Life Time Plan"}

                      {!!li.validTo && (
                        <>
                          {" "}
                          <span>Till Date</span>{" "}
                          {moment(li.validTo).format("MM-DD-YYYY")}
                        </>
                      )}
                      {!!li.planDuration && li.planDuration + "/ year"}
                    </span>
                    <p>{li.planDescription}</p>

                    <ul>
                      {li.isParkLicense ? (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Park License
                        </li>
                      ) : (
                        ""
                      )}

                      {li.isKennelLicense && (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Kennel License
                        </li>
                      )}

                      {li.isDogLicense && (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Dog License
                        </li>
                      )}

                      {li.isRenewal && (
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17.011"
                            height="17.011"
                            viewBox="0 0 17.011 17.011"
                          >
                            <path
                              id="Icon_material-check-box"
                              data-name="Icon material-check-box"
                              d="M19.621,4.5H6.39A1.89,1.89,0,0,0,4.5,6.39V19.621a1.89,1.89,0,0,0,1.89,1.89H19.621a1.89,1.89,0,0,0,1.89-1.89V6.39A1.89,1.89,0,0,0,19.621,4.5ZM11.115,17.731,6.39,13.005l1.333-1.333,3.393,3.383,7.173-7.173,1.333,1.342Z"
                              transform="translate(-4.5 -4.5)"
                              fill="#fff"
                            />
                          </svg>
                          Renewal
                        </li>
                      )}
                    </ul>
                  </div>
                </Col>
              ))}
            </Row>
          </Card>
        </Container>
        <Modal isOpen={modal}>
          <ModalHeader>License validation</ModalHeader>
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label for="exampleEmail">Valid From Date</Label>
                <Input
                  type="date"
                  onBlur={handleBlur}
                  name="validFromDate"
                  value={moment(values.validFromDate).format("YYYY-MM-DD")}
                  invalid={
                    touched.validFromDate && errors.validFromDate ? true : false
                  }
                  onChange={handleChange}
                  id="examplevalidFromDate"
                  placeholder="Enter your validFromDate"
                />
                <FormFeedback>
                  {touched.validFromDate && errors.validFromDate && (
                    <div> {errors.validFromDate}</div>
                  )}
                </FormFeedback>
              </FormGroup>
              {/* { !isLifeTimePlan && planDuration ? 
                (<Label for="exampleEmail">Valid To Date {moment(values.validFromDate).add(planDuration, 'year').format("DD-MM-YYYY")} </Label>) : (<div></div>)
              }
              { !isLifeTimePlan && validTo ? 
                (<Label for="exampleEmail">Valid To Date  {moment(validTo).format("DD-MM-YYYY")} </Label>) : (<div></div>)
              } */}
              {!isLifeTimePlan && planDuration ?
                (<FormGroup>
                  <Label for="exampleEmail">Valid Till</Label>
                  <InputGroup>
                    <Input
                      type="date"
                      onBlur={handleBlur}
                      name="validToDate"
                      value={moment(validDateTo1).format("YYYY-MM-DD")}
                      invalid={
                        touched.validToDate && errors.validToDate ? true : false
                      }
                      onChange={(e) => handleValidToDateChange1(e)}
                      id="exampleEmail1"
                    />
                    <FormFeedback>
                      {touched.validToDate && errors.validToDate && (
                        <div> {errors.validToDate}</div>
                      )}
                    </FormFeedback>
                  </InputGroup>
                </FormGroup>
                ) : <div></div> }
 { !isLifeTimePlan && validTo ? 
                (<FormGroup>
                  <Label for="exampleEmail">Valid Till</Label>
                  <InputGroup>
                    <Input
                      type="date"
                      onBlur={handleBlur}
                      name="validToDate"
                      value={moment(validDateTo2).format("YYYY-MM-DD")}
                      // invalid={
                      //   touched.validToDate && errors.validToDate ? true : false
                      // }
                      onChange={(e) => handleValidToDateChange2(e)}
                      id="exampleEmail2"
                    />
                    {/* <FormFeedback>
                      {touched.validToDate && errors.validToDate && (
                        <div> {errors.validToDate}</div>
                      )}
                    </FormFeedback> */}
                  </InputGroup>
                </FormGroup>
                ) : <div></div> }

              {reqNu && (
                <FormGroup>
                  <Label for="exampleEmail">Dog License Number</Label>
                  <InputGroup>
                    <Input
                      type="text"
                      onBlur={handleBlur}
                      name="dogLicenseNumber"
                      value={values.dogLicenseNumber}
                      invalid={
                        touched.dogLicenseNumber && errors.dogLicenseNumber
                          ? true
                          : false
                      }
                      onChange={handleChange}
                      id="exampleEmail"
                    />

                    <FormFeedback>
                      {touched.dogLicenseNumber && errors.dogLicenseNumber && (
                        <div> {errors.dogLicenseNumber}</div>
                      )}
                    </FormFeedback>
                  </InputGroup>
                </FormGroup>
              )}
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit">
                {" "}
                {DeleverSpinner ? <Spinner /> : "Deliver"}{" "}
              </Button>{" "}
              <Button color="secondary" onClick={Datetoggle}>
                Cancel
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    </div>
  );
}

export default ViewLicense;
